import { useQuery } from '@tanstack/react-query';
import { savedWork } from './engine';
import { useOutboxStatus } from './sender';

/**
 * The work saved on this PC, for a screen to show, read again as it is saved,
 * sent or refused — here or in another tab.
 *
 * Read whatever the line is doing: it is on this PC. The query cache holds
 * back anything it takes for a network read while offline, and without
 * `always` the work waiting to be sent would vanish from every list at the
 * very moment it is waiting.
 */
export function useSavedWork() {
  const status = useOutboxStatus();
  return useQuery({
    queryKey: ['outbox', status.waiting, status.refused, status.lastSentAt],
    queryFn: savedWork,
    staleTime: 0,
    networkMode: 'always',
  });
}
